var _defs, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintainIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 340.795,
    height: 723.176,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999}.cls-2{fill:#666}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.26 391.011l-40.184 10.753-29.404-29.423 10.78-40.177 40.183-10.752 29.404 29.423-10.779 40.176z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 270.759,
    cy: 361.448,
    r: 18.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.08 230.306l-40.184 10.753-29.404-29.424 10.78-40.176 40.183-10.753 29.404 29.423-10.779 40.177z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 271.579,
    cy: 200.742,
    r: 18.38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.26 69.6l-40.184 10.753-29.404-29.424 10.78-40.176L281.635 0l29.404 29.423L300.26 69.6z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 270.759,
    cy: 40.036,
    r: 18.38
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.08 551.717l-40.184 10.753-29.404-29.423 10.78-40.177 40.183-10.753 29.404 29.424-10.779 40.176z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 271.579,
    cy: 522.154,
    r: 18.38
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.26 712.423l-40.184 10.753-29.404-29.424 10.78-40.176 40.183-10.753 29.404 29.424-10.779 40.176z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 270.759,
    cy: 682.859,
    r: 18.38
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.756 421.134l-36.926-36.866a3.404 3.404 0 01-.898-2.871l6.94-38.035a3.327 3.327 0 012.628-2.62l38.054-6.752a3.326 3.326 0 012.869.906l36.845 36.785a6.507 6.507 0 009.922-.806c5.915-8.273 8.799-18.108 8.81-26.062a10.455 10.455 0 00-.08-1.64c-.56-10.25-6.268-32.232-24.282-49.23-17.36-16.505-49.64-33.769-85.657-18.569-4.348 1.798-10.09 3.84-16.15-2.236C216.774 266.898 68.67 109.18 68.67 109.18c-12.688-14.776-36.221-13.743-49.933-.152a36.728 36.728 0 00-10.532 25.65 31.557 31.557 0 0010.707 24.284s156.481 147.315 163.605 154.54c3.193 3.285 4.172 6.32 4.168 9.108a15.47 15.47 0 01-1.977 7.048 57.706 57.706 0 00-6.105 26.557c-.031 21.974 10.103 45.11 24.186 59.233 19.978 20.035 39.323 23.752 49.244 24.34a43.843 43.843 0 0028.054-8.734 6.674 6.674 0 00.67-9.92zM36.645 143.164a11.538 11.538 0 1116.317.022 11.682 11.682 0 01-16.317-.023z",
    transform: "translate(-8.205 -6.824)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintainIcon);
export default __webpack_public_path__ + "static/media/maintainIcon.7b0d0a18d1754806e219bb626749dceb.svg";
export { ForwardRef as ReactComponent };